module.exports = __webpack_public_path__ + "img/20190618162229723.4d327a3d.png";